module.exports = __webpack_public_path__ + "static/img/ifc.5155bea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/ifc.png
// module id = evHi
// module chunks = 53